module.exports = __webpack_public_path__ + "img/st-logo.2d31f36c.png";